
import '../assets/style/App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import FirstStep from "./Onboarding/FirstStep";
import CheckCode from "./Onboarding/CheckCode";
import Documents from "./Onboarding/Documents";
import SetPassword from "./Onboarding/SetPassword";
import AditionalData from "./Onboarding/AditionalData";
import Welcome from "./Onboarding/Finish";
// import AddCard from './Onboarding/AddCard';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
            <Route path="/" element={<FirstStep />} />
            <Route path="/verificar-dispositivo" element={<CheckCode/>} />
            <Route path="/documentos" element={<Documents/>} />
            <Route path="/datos-adicionales" element={<AditionalData/>} />
            <Route path="/clave" element={<SetPassword/>} />
            <Route path="/bienvenido" element={<Welcome/>} />
            {/* <Route path="/agregar-tarjeta" element={<AddCard/>} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
